import React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import TextFieldGroup from "./../../common/TextFieldGroup";
import "./ooredoo.css";
import credits, { EMPTY_CREDIT } from "./credits";
import SubNavOoredoo from "./SubNavOoredoo";
import Selected from "./Selected";
import CompaniesNav from "../../common/CompaniesNav";
import logo from "../../../assests/images/bundles/ooredoo/banner.jpg";
import { jsonParser } from "shared/utils/ppUtils";
import { Tooltip } from "@mui/material";
import getOoredooCachedImageUrl from "shared/utils/ooredooImageCache";
import Notiflix from "notiflix";
import translate from "../../../i18n/translate";

const MAX_OOREDOO_CARDS = 3;

const CreditOoredoo = ({ auth, loading }) => {
  const history = useHistory().location.pathname;
  const mobileNo = history.split("/")[4];
  const state = useHistory().location.state;

  const [price, setPrice] = useState(null);
  const [g3, setG3] = useState("");
  const [min, setMin] = useState("");
  const [credit, setCredit] = useState("");
  const [creditQueue, setCreditQueue] = useState([]);
  const [rom, setRom] = useState("");
  const [shabab, setShabab] = useState("");
  const [columnStyle, setColumnStyle] = useState(
    "col-lg-3 col-md-4 col-sm-6 col-6"
  );
  const [imageRefreshToken, setImageRefreshToken] = useState(0);

  const dispatchSessionStorageEvent = () => {
    try {
      window.dispatchEvent(new Event("sessionStorageChanged"));
    } catch (error) {
      // ignore dispatch errors
    }
  };

  const persistCreditQueue = (queue) => {
    if (queue?.length) {
      sessionStorage.ooredooCreditQueue = JSON.stringify(queue);
      sessionStorage.ooredooCredit = JSON.stringify(
        queue[queue.length - 1] || {}
      );
    } else {
      sessionStorage.removeItem("ooredooCreditQueue");
      sessionStorage.removeItem("ooredooCredit");
    }
    dispatchSessionStorageEvent();
  };

  const handleCreditQueueChange = (queue) => {
    const normalizedQueue = (queue || []).map((item, index) => ({
      ...item,
      type: item?.type || "credit",
      __uid:
        item?.__uid ||
        `${item?.id || item?.bundleid || "credit"}-${index}-${Date.now().toString(
          36
        )}`,
    }));
    setCreditQueue(normalizedQueue);
    setCredit(normalizedQueue[normalizedQueue.length - 1] || "");
    persistCreditQueue(normalizedQueue);
  };

  const addCreditToQueue = (creditItem, sourceElement) => {
    if (!creditItem) {
      return;
    }

    const amountValue = Number(creditItem.price);
    if (!creditItem.price || Number.isNaN(amountValue) || amountValue <= 0) {
      Notiflix.Notify.warning(
        translate("Please enter a valid credit amount before adding the card.")
      );
      return;
    }

    if (creditQueue.length >= MAX_OOREDOO_CARDS) {
      Notiflix.Notify.warning(
        translate("You can select up to 3 cards per payment.")
      );
      return;
    }

    const enrichedCredit = {
      ...creditItem,
      price: creditItem.price,
      type: creditItem.type || "credit",
      __uid:
        creditItem.__uid ||
        `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
    };

    const updatedQueue = [...creditQueue, enrichedCredit];
    handleCreditQueueChange(updatedQueue);

    if (window.triggerBundleAnimation && sourceElement) {
      window.triggerBundleAnimation("credit", sourceElement);
    }
  };

  useEffect(() => {
    const handleSessionStorageChange = () => {
      document.title = "Ooredoo Credit | Phone Play";
      const storedQueueRaw =
        sessionStorage.ooredooCreditQueue || sessionStorage.ooredooCredit;
      const parsedQueue = jsonParser(storedQueueRaw);
      if (Array.isArray(parsedQueue) && parsedQueue.length) {
        handleCreditQueueChange(parsedQueue);
      } else if (parsedQueue) {
        handleCreditQueueChange([parsedQueue]);
      } else {
        if (creditQueue.length || credit?.price) {
          setCreditQueue([]);
          setCredit("");
        }
        sessionStorage.removeItem("ooredooCreditQueue");
        sessionStorage.removeItem("ooredooCredit");
      }
      if (sessionStorage.ooredoo3g) {
        setG3(jsonParser(sessionStorage.ooredoo3g));
      }
      if (sessionStorage.ooredooMin) {
        setMin(jsonParser(sessionStorage.ooredooMin));
      }
      if (sessionStorage.ooredooRom) {
        setRom(jsonParser(sessionStorage.ooredooRom));
      }
      if (sessionStorage.ooredooSuper) {
        setShabab(jsonParser(sessionStorage.ooredooSuper));
      }
      refreshColumnStyle();
    };
    handleSessionStorageChange();

    window.addEventListener(
      "sessionStorageChanged",
      handleSessionStorageChange
    );

    // Clean up the event listener
    return () => {
      window.removeEventListener(
        "sessionStorageChanged",
        handleSessionStorageChange
      );
    };
  }, [mobileNo, history]);

  const onChange = (e) => {
    const value = e.target.value;
    if (value.includes(".") || value.includes(",")) {
      e.target.value = Math.floor(value);
    }
    const selectedCredit = { ...EMPTY_CREDIT, price: e.target.value };
    setPrice(e.target.value);
    setCredit(selectedCredit);
  };
  const onTypeClick = (item, event) => {
    const clickedCard = event?.currentTarget;
    addCreditToQueue(item, clickedCard);
    document
      .getElementsByTagName("html")[0]
      .scrollIntoView({ behavior: "smooth" });
  };

  const refreshColumnStyle = () => {
    switch (localStorage.size) {
      case "default":
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6");
        break;
      case "column3":
        setColumnStyle("col-lg-4 col-md-6 col-sm-6 col-6 card-lg");
        break;
      case "column4":
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6 card-md");
        break;
      case "column6":
        setColumnStyle("col-lg-2 col-md-2 col-sm-4 col-6 card-sm");
        break;
      default:
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6");
    }
  };
  let topDiv = null;
  // Import Tooltip from MUI at the top of your file:
  // import Tooltip from '@mui/material/Tooltip';

  return (
    <>
      <div ref={(ref) => (topDiv = ref)} className="ooredoo-container">
        <CompaniesNav
          providerId={
            window?.history?.state?.state?.provider_Id
              ? window?.history?.state?.state?.provider_Id
              : state?.provider_id
          }
          title="Ooredoo"
          logo={logo}
          mobile={mobileNo}
          onRefresh={() => setImageRefreshToken(Date.now())}
          actionWidth="130px"
          backLink="/company/ooredoo/MobileNumer"
          comingFromReports={
            !window?.history?.state?.state?.provider_Id && state?.provider_id
          }
          credit={credit}
        />
        <div className="row">
          <div className="col-12">
            <SubNavOoredoo mobile={mobileNo} />
          </div>
        </div>
        <div className="position-relative">
          <Selected
            min={min}
            setMin={setMin}
            g3={g3}
            setg3={setG3}
            credit={credit}
            setCredit={setCredit}
            creditQueue={creditQueue}
            onCreditQueueChange={handleCreditQueueChange}
            shabab={shabab}
            setShabab={setShabab}
            setRom={setRom}
            rom={rom}
            imageRefreshToken={imageRefreshToken}
          />

          <hr
            className="mt-3"
            style={{
              border: "2px solid #42ace3",
              backgroundColor: "#42ace3",
              fontWeight: "bolder",
            }}
          />

          <div className="row ">
            <div className={`${columnStyle} my-2`}>
              <div className="card card-credit">
                <Tooltip title="Enter any amount you wish" arrow>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={(e) =>
                      onTypeClick({ ...EMPTY_CREDIT, price: price }, e)
                    }
                  >
                    <div className="card">
                      <img
                        alt=""
                        src={
                          getOoredooCachedImageUrl(
                            EMPTY_CREDIT.url,
                            imageRefreshToken
                          ) || EMPTY_CREDIT.url
                        }
                      ></img>
                      <TextFieldGroup
                        style={{
                          width: "calc(50% - 20px)",
                          height: "70%",
                          padding: 0,
                          position: "absolute",
                          top: "50%",
                          left: "calc(50% + 12px)",
                          transform: "translateY(-50%)",
                          fontSize: "2rem",
                          fontFamily: '"Montserrat", sans-serif',
                          textAlign: "center",
                          outline: "rgb(16, 16, 16) auto 4px",
                          color: "#bb0d0e",
                        }}
                        name="price"
                        type="number"
                        onChange={onChange}
                        min={10}
                      />
                    </div>
                  </div>
                </Tooltip>
              </div>
            </div>
            {credits.map((item, i) => (
              <div key={i.toString()} className={`${columnStyle} my-2`}>
                <div className="card charge-card">
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={(e) => onTypeClick(item, e)}
                  >
                    <div className="card">
                      <img
                        alt=""
                        src={getOoredooCachedImageUrl(
                          item.url,
                          imageRefreshToken
                        )}
                      ></img>
                      {item && item.des}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  loading: state.companies.loading,
});

export default connect(mapStateToProps)(CreditOoredoo);
